<template>
  <div v-cloak class="grid-container text-md pb-3">
    <trek-loading page :is-loading="isLoading" />
    <form id="warranty-claim-form" @submit.prevent="submitFeedback">
      <product-feedback-header
        :base-properties="baseProperties"
        :feedback-data="feedbackData"
        :show-success="showSuccessNotification"
      />
      <section class="my-6">
        <section-header size="md" variants="dividing">
          <heading level="3" size="md" qaid="product-feedback__info-header" v-html="bp('productInformation')" />
        </section-header>
        <product-feedback-product-details :base-properties="baseProperties" :feedback-data="feedbackData" />
      </section>

      <section v-if="showFeedbackDetails" class="my-6">
        <section-header size="md" variants="dividing">
          <heading level="3" size="md" qaid="product-feedback__details-header" v-html="bp('feedbackDetailsHeader')" />
        </section-header>
        <product-feedback-details :base-properties="baseProperties" :feedback-data="feedbackData" />

        <hr class="rule my-4" />

        <div class="buttons">
          <trek-button primary type="submit" qaid="product-feedback__submit" :disabled="!showFeedbackDetails">
            {{ bp('feedbackSubmit') }}
          </trek-button>
        </div>
      </section>
    </form>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import ProductFeedbackHeader from './ProductFeedbackHeader';
import ProductFeedbackDetails from './ProductFeedbackDetails';
import ProductFeedbackProductDetails from './ProductFeedbackProductDetails';
import TrekButton from '@/components/TrekButton';
import every from 'lodash/every';
import SectionHeader from '@/components/SectionHeader';
import TrekLoading from '@/components/TrekLoading';

export default {
  components: {
    ProductFeedbackHeader,
    ProductFeedbackDetails,
    ProductFeedbackProductDetails,
    TrekButton,
    SectionHeader,
    TrekLoading,
  },
  props: {
    claimLine: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      showSuccessNotification: false,
    };
  },

  computed: {
    ...mapState('productFeedback', ['feedbackData', 'showFeedbackDetails', 'validators', 'isLoading']),
  },

  mounted() {
    this.fetchFeedbackData();
    this.validators.push(this.$validator);
  },

  methods: {
    validateForm(validate) {
      let validatorPromises = [];
      this.validators.forEach((validator) => {
        validatorPromises.push(
          new Promise(function(resolve) {
            resolve(validator.validateAll());
          })
        );
      });

      // Use Promise.all to run all validator promises concurrently and catching the final result in one function in order
      // to save or ignore
      return Promise.all(validatorPromises).then((values) => {
        if (every(values, (value) => value)) {
          return this.saveProcessedFeedback(validate);
        } else {
          window.vm.$scrollTo('body');
        }
      });
    },
    submitFeedback() {
      this.validateForm(false).then((submitResponse) => {
        if (submitResponse && submitResponse.data && submitResponse.data.meta.feedback.type === 'success') {
          const feedbackMsg = this.bp('submitConfirm', submitResponse.data.data.id);
          this.setFeedbackMsg(feedbackMsg);
          window.location = `${ACC.config.encodedContextPath}/warranty-claim/all-warranty-claims/`;
        }
      });
    },

    ...mapActions('productFeedback', [
      'fetchFeedbackData',
      'updateFeedbackProperty',
      'saveProcessedFeedback',
      'setFeedbackMsg',
    ]),
    ...mapActions('storage', ['setFeedbackMsg']),
  },
};
</script>
